export const formatDate = 'DD MMM YYYY';
export const formatDateTime = 'DD MMM YYYY HH:mm:ss';

export const confirmModalUnsavedChangesProps = {
  message: 'Warning',
  description: 'Are you sure you want to leave? You have unsaved changes.',
};

export const confirmModalDeleteProps = {
  message: 'Delete item',
  description: 'Are you sure you want to delete this item? This cannot be undone later.',
  okText: 'Delete',
};

export const confirmModalDeleteUserProps = {
  message: 'Delete item',
  description: 'Are you sure you want to delete this customer? Be advised, the action cannot be undone.',
  okText: 'OK',
};

export const confirmModalDifferentCurrenciesProps = {
  message: 'Warning',
  description:
    'The transaction currency and your bank account currency don’t match. Are you sure you want to continue?',
  cancelText: 'No',
  okText: 'Yes',
};
